const benefits = [
  {
    icon: 'ri-shield-check-line',
    gradient: 'from-emerald-500 to-teal-500',
    title: 'Satisfaction Guaranteed or Refunded',
    desc: 'If you are not fully satisfied the first week, we will refund you in full — no questions asked. Your satisfaction is our priority.',
  },
  {
    icon: 'ri-flashlight-line',
    gradient: 'from-orange-500 to-pink-500',
    title: 'Instant Activation',
    desc: 'Once registered, you get instant access with your login credentials. Start watching immediately.',
  },
  {
    icon: 'ri-price-tag-3-line',
    gradient: 'from-yellow-500 to-amber-500',
    title: 'Competitive & Transparent Pricing',
    desc: 'Clear, straightforward pricing with no hidden fees. Great value for the quality and breadth of content we offer.',
  },
  {
    icon: 'ri-film-line',
    gradient: 'from-[#862ce0] to-[#c026d3]',
    title: 'Top Channels & VoD',
    desc: 'Our VoD service gives you access to the latest movies and series. Live channels and pay-per-view available.',
  },
  {
    icon: 'ri-customer-service-2-line',
    gradient: 'from-cyan-500 to-blue-500',
    title: 'Dedicated Customer Support',
    desc: 'Our team is available 7 days a week from 10am to midnight. Whether it\'s a technical issue or a billing question, we\'re here to help.',
  },
];

const Benefits = () => (
  <section className="py-10 md:py-20 bg-gradient-to-b from-black via-black to-[#862ce0]/5 relative overflow-hidden">
    <div className="absolute top-0 right-0 w-96 h-96 bg-[#862ce0]/10 rounded-full blur-3xl pointer-events-none"></div>
    <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#862ce0]/10 rounded-full blur-3xl pointer-events-none"></div>

    <div className="max-w-7xl mx-auto px-4 relative z-10">
      <div className="text-center mb-8 md:mb-16">
        <span className="inline-block px-4 py-1 bg-[#862ce0]/10 text-[#b47ef3] rounded-full text-sm font-semibold mb-3 md:mb-4">
          WHY US AND NOT OTHERS
        </span>
        <p className="text-gray-400 text-base md:text-lg max-w-2xl mx-auto">
          7 years of experience in premium streaming with thousands of satisfied customers
        </p>
      </div>

      <div className="grid lg:grid-cols-2 gap-6 md:gap-12 items-center">
        {/* Image */}
        <div className="relative group">
          <div className="absolute inset-0 bg-gradient-to-r from-[#862ce0]/20 to-[#c026d3]/20 rounded-3xl blur-2xl group-hover:blur-3xl transition-all duration-500"></div>
          <div className="relative rounded-3xl overflow-hidden">
            <img
              alt="Premium Service"
              className="w-full h-auto transform group-hover:scale-105 transition-transform duration-500"
              loading="lazy"
              src="https://4kkdream.com/benefits-hero-Dr22Nijq.png"
            />
          </div>
          <div className="absolute -bottom-4 md:-bottom-6 -left-4 md:-left-6 bg-gradient-to-br from-[#862ce0] via-[#9a38e8] to-[#7020c8] text-white rounded-xl md:rounded-2xl px-4 py-3 md:px-8 md:py-6 hover:scale-105 transition-transform duration-300">
            <div className="text-center">
              <div className="text-[10px] md:text-xs font-semibold uppercase tracking-wider mb-1">EXPERIENCE OF</div>
              <div className="text-2xl md:text-4xl font-bold">7 Years</div>
            </div>
          </div>
        </div>

        {/* Benefits list */}
        <div className="grid gap-3 md:gap-6">
          {benefits.map((b) => (
            <div
              key={b.title}
              className="group bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl md:rounded-2xl p-4 md:p-6 hover:border-[#862ce0]/50 transition-all duration-300"
            >
              <div className="flex items-start gap-3 md:gap-4">
                <div className={`w-10 h-10 md:w-12 md:h-12 rounded-lg md:rounded-xl bg-gradient-to-br ${b.gradient} p-2.5 md:p-3 flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300`}>
                  <i className={`${b.icon} text-white text-base`}></i>
                </div>
                <div className="flex-1">
                  <h3 className="text-base md:text-xl font-bold mb-1 md:mb-2 group-hover:text-[#b47ef3] transition-colors text-white">
                    {b.title}
                  </h3>
                  <p className="text-sm md:text-base text-gray-400 leading-relaxed">{b.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default Benefits;
